/**
 * Copy for the Updater-owned chrome around the iframe. Everything inside the
 * frame is Public Grid's, including all plan, ESI ID and soft-credit-check
 * disclosure — we must not restate any of it here.
 */
export const COPY = {
  heading: 'Connect your power',
  iframeTitle: 'Utility setup',
  error: {
    heading: "We couldn't start your power setup",
    description:
      'Something went wrong on our side. You can still set up electricity directly with a provider.',
    cta: 'View utility providers',
  },
} as const;
